var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Ukraine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M44,24H4c0,11.046,8.954,20,20,20S44,35.046,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M24,4C12.954,4,4,12.954,4,24h40C44,12.954,35.046,4,24,4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Ukraine);
export default __webpack_public_path__ + "static/media/icons8-ukraine.b585c11b18d8ba9c275934d609c5c04b.svg";
export { ForwardRef as ReactComponent };